// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for printable structure availability - Card Layout */
body.print-mode {
  margin: 0;
  padding: 0;
  background-color: #fff;
  font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  font-size: 9pt;
  color: #333;
  line-height: 1.4;
}

/* Default styles for .printable-container are fine as they are the top-level scope */
.printable-container {
  width: 100%;
  max-width: 210mm; /* A4 width */
  margin: 0 auto;
  padding: 10mm 8mm; /* Slightly reduced horizontal padding for cards */
  box-sizing: border-box;
}

.printable-container .printable-header {
  border-bottom: 2px solid #005A9C;
  padding-bottom: 4mm;
  margin-bottom: 6mm;
  text-align: center;
}

.printable-container .type-group {
  margin-bottom: 8mm; /* Space between type groups */
  page-break-after: auto; /* Allow page break after a group if needed, but not inside */
}
.printable-container .type-group:last-child {
  margin-bottom: 0;
}

.printable-container .type-heading {
  font-size: 14pt;
  font-weight: 600;
  color: #333;
  padding-bottom: 2mm;
  margin-bottom: 4mm;
  border-bottom: 1px solid #ccc;
  page-break-after: avoid; /* Try to keep heading with its content */
}

.printable-container .printable-header h1 {
  font-size: 18pt;
  font-weight: 600;
  color: #003366;
  margin-bottom: 3mm;
}

.printable-container .printable-header p {
  font-size: 9pt;
  color: #555;
  margin-bottom: 1.5mm;
}

.printable-container .cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5mm; /* Gap between cards */
  justify-content: flex-start; /* Align cards to the start */
}

.printable-container .structure-card {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  /* overflow: hidden; To contain image border-radius */
  width: calc(50% - 2.5mm); /* Two cards per row, considering gap */
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  page-break-inside: avoid; /* Try to keep card content together */
}

.printable-container .card-image {
  width: 100%;
  height: 260px; /* Increased height for larger image */
  object-fit: cover; /* Cover to fill, might crop; use 'contain' if full image is needed */
  border-bottom: 1px solid #eee;
}

.printable-container .image-placeholder {
  width: 100%;
  height: 260px; /* Increased height for larger image */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #888;
  font-size: 9pt;
  border-bottom: 1px solid #eee;
}

.printable-container .card-details {
  padding: 3mm;
  font-size: 8pt;
  flex-grow: 1; /* Allow details to take remaining space */
  display: flex;
  flex-direction: column;
}

.printable-container .card-name {
  font-size: 10pt;
  font-weight: 600;
  color: #005A9C;
  margin-bottom: 2mm;
}

.printable-container .card-info {
  margin-bottom: 1mm;
  color: #444;
  line-height: 1.3;
  white-space: pre-line;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}
.printable-container .card-info strong {
  font-weight: 800;
  color: #111;
}

.printable-container .description-text {
  font-weight: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
}

.printable-container .bold-words {
  font-weight: 600 !important;
  color: #111;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.printable-container .description-link {
  color: #005A9C;
  text-decoration: underline;
  word-break: break-all;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.printable-container .description-link:hover {
  color: #003366;
  text-decoration: none;
}

.printable-container .card-pricing {
  margin-top: auto; /* Push pricing to the bottom of the card */
  padding-top: 2mm;
  border-top: 1px dashed #eee;
  display: flex;
  justify-content: space-between;
  font-size: 8.5pt;
}
.printable-container .card-pricing p {
  margin-bottom: 0;
}
.printable-container .card-pricing strong {
  font-weight: 800;
}

.printable-container .no-results-message {
  width: 100%;
  text-align: center;
  padding: 20mm 0;
  font-size: 10pt;
  color: #666;
}

.printable-container .printable-footer {
  margin-top: 8mm;
  padding-top: 4mm;
  border-top: 1px solid #005A9C;
  font-size: 7.5pt;
  color: #444;
  text-align: center;
}
.printable-container .printable-footer .flex {
  display: flex;
}
.printable-container .printable-footer .justify-between {
  justify-content: space-between;
}
.printable-container .printable-footer .mt-1 {
    margin-top: 0.25rem;
}

/* Print-specific styles */
@media print {
  body * {
    print-color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
  }

  .printable-container-wrapper,
  .printable-container-wrapper * {
    visibility: visible !important;
  }

  .printable-container-wrapper {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    min-height: 100vh !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    background-color: #fff !important;
  }

  .printable-container {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: none !important;
    box-shadow: none !important;
    border: none !important;
  }

  @page {
    size: A4 portrait;
    margin: 10mm 8mm;
  }

  body.print-mode {
    font-size: 8.5pt;
    background-color: #fff !important;
  }

  .cards-container {
    gap: 4mm;
  }

  .structure-card {
    width: calc(50% - 2mm);
    box-shadow: none;
    border: 1px solid #ccc;
    height: auto;
  }

  .card-image {
    height: 140px;
  }
  .image-placeholder {
    height: 140px;
  }

  .card-details {
    font-size: 7.5pt;
  }
  .card-name {
    font-size: 9pt;
  }
  .card-pricing {
    font-size: 8pt;
  }

  .type-heading {
    font-size: 12pt !important;
    color: #000 !important;
    border-bottom-color: #aaa !important;
    margin-bottom: 3mm !important;
  }

  .printable-header h1 {
    color: #000 !important;
  }
  .printable-header {
    border-bottom-color: #888 !important;
  }
  .printable-footer {
    border-top-color: #888 !important;
    color: #000 !important;
  }
  .card-name {
    color: #000 !important;
  }

  .description-link {
    color: #000 !important;
    text-decoration: underline !important;
    word-break: break-all !important;
  }
  
  .description-link::after {
    content: " (" attr(href) ")";
    font-size: 7pt;
    color: #666 !important;
    text-decoration: none !important;
  }

  .bold-words {
    font-weight: 600 !important;
    color: #000 !important;
  }

  .card-info, .description-text {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    hyphens: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableStructureAvailability.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,sEAAsE;EACtE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE,WAAW;EACX,gBAAgB,EAAE,aAAa;EAC/B,cAAc;EACd,iBAAiB,EAAE,kDAAkD;EACrE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,8BAA8B;EAClD,sBAAsB,EAAE,6DAA6D;AACvF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB,EAAE,yCAAyC;AACpE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ,EAAE,sBAAsB;EAChC,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qDAAqD;EACrD,wBAAwB,EAAE,uCAAuC;EACjE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,wBAAwB,EAAE,sCAAsC;AAClE;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,sCAAsC;EACrD,iBAAiB,EAAE,qEAAqE;EACxF,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,sCAAsC;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY,EAAE,0CAA0C;EACxD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB,EAAE,2CAA2C;EAC7D,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;EACE;IACE,oCAAoC;IACpC,4CAA4C;EAC9C;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;IACjC,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;IAC5B,cAAc;IACd,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;IAChC,oCAAoC;IACpC,iCAAiC;IACjC,wBAAwB;EAC1B;AACF","sourcesContent":["/* Styles for printable structure availability - Card Layout */\nbody.print-mode {\n  margin: 0;\n  padding: 0;\n  background-color: #fff;\n  font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n  font-size: 9pt;\n  color: #333;\n  line-height: 1.4;\n}\n\n/* Default styles for .printable-container are fine as they are the top-level scope */\n.printable-container {\n  width: 100%;\n  max-width: 210mm; /* A4 width */\n  margin: 0 auto;\n  padding: 10mm 8mm; /* Slightly reduced horizontal padding for cards */\n  box-sizing: border-box;\n}\n\n.printable-container .printable-header {\n  border-bottom: 2px solid #005A9C;\n  padding-bottom: 4mm;\n  margin-bottom: 6mm;\n  text-align: center;\n}\n\n.printable-container .type-group {\n  margin-bottom: 8mm; /* Space between type groups */\n  page-break-after: auto; /* Allow page break after a group if needed, but not inside */\n}\n.printable-container .type-group:last-child {\n  margin-bottom: 0;\n}\n\n.printable-container .type-heading {\n  font-size: 14pt;\n  font-weight: 600;\n  color: #333;\n  padding-bottom: 2mm;\n  margin-bottom: 4mm;\n  border-bottom: 1px solid #ccc;\n  page-break-after: avoid; /* Try to keep heading with its content */\n}\n\n.printable-container .printable-header h1 {\n  font-size: 18pt;\n  font-weight: 600;\n  color: #003366;\n  margin-bottom: 3mm;\n}\n\n.printable-container .printable-header p {\n  font-size: 9pt;\n  color: #555;\n  margin-bottom: 1.5mm;\n}\n\n.printable-container .cards-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5mm; /* Gap between cards */\n  justify-content: flex-start; /* Align cards to the start */\n}\n\n.printable-container .structure-card {\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  /* overflow: hidden; To contain image border-radius */\n  width: calc(50% - 2.5mm); /* Two cards per row, considering gap */\n  box-shadow: 0 2px 4px rgba(0,0,0,0.08);\n  display: flex;\n  flex-direction: column;\n  page-break-inside: avoid; /* Try to keep card content together */\n}\n\n.printable-container .card-image {\n  width: 100%;\n  height: 260px; /* Increased height for larger image */\n  object-fit: cover; /* Cover to fill, might crop; use 'contain' if full image is needed */\n  border-bottom: 1px solid #eee;\n}\n\n.printable-container .image-placeholder {\n  width: 100%;\n  height: 260px; /* Increased height for larger image */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f0f0;\n  color: #888;\n  font-size: 9pt;\n  border-bottom: 1px solid #eee;\n}\n\n.printable-container .card-details {\n  padding: 3mm;\n  font-size: 8pt;\n  flex-grow: 1; /* Allow details to take remaining space */\n  display: flex;\n  flex-direction: column;\n}\n\n.printable-container .card-name {\n  font-size: 10pt;\n  font-weight: 600;\n  color: #005A9C;\n  margin-bottom: 2mm;\n}\n\n.printable-container .card-info {\n  margin-bottom: 1mm;\n  color: #444;\n  line-height: 1.3;\n  white-space: pre-line;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n.printable-container .card-info strong {\n  font-weight: 800;\n  color: #111;\n}\n\n.printable-container .description-text {\n  font-weight: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  max-width: 100%;\n}\n\n.printable-container .bold-words {\n  font-weight: 600 !important;\n  color: #111;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.printable-container .description-link {\n  color: #005A9C;\n  text-decoration: underline;\n  word-break: break-all;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n.printable-container .description-link:hover {\n  color: #003366;\n  text-decoration: none;\n}\n\n.printable-container .card-pricing {\n  margin-top: auto; /* Push pricing to the bottom of the card */\n  padding-top: 2mm;\n  border-top: 1px dashed #eee;\n  display: flex;\n  justify-content: space-between;\n  font-size: 8.5pt;\n}\n.printable-container .card-pricing p {\n  margin-bottom: 0;\n}\n.printable-container .card-pricing strong {\n  font-weight: 800;\n}\n\n.printable-container .no-results-message {\n  width: 100%;\n  text-align: center;\n  padding: 20mm 0;\n  font-size: 10pt;\n  color: #666;\n}\n\n.printable-container .printable-footer {\n  margin-top: 8mm;\n  padding-top: 4mm;\n  border-top: 1px solid #005A9C;\n  font-size: 7.5pt;\n  color: #444;\n  text-align: center;\n}\n.printable-container .printable-footer .flex {\n  display: flex;\n}\n.printable-container .printable-footer .justify-between {\n  justify-content: space-between;\n}\n.printable-container .printable-footer .mt-1 {\n    margin-top: 0.25rem;\n}\n\n/* Print-specific styles */\n@media print {\n  body * {\n    print-color-adjust: exact !important;\n    -webkit-print-color-adjust: exact !important;\n  }\n\n  .printable-container-wrapper,\n  .printable-container-wrapper * {\n    visibility: visible !important;\n  }\n\n  .printable-container-wrapper {\n    position: absolute !important;\n    left: 0 !important;\n    top: 0 !important;\n    width: 100% !important;\n    min-height: 100vh !important;\n    height: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    background-color: #fff !important;\n  }\n\n  .printable-container {\n    margin: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-width: none !important;\n    box-shadow: none !important;\n    border: none !important;\n  }\n\n  @page {\n    size: A4 portrait;\n    margin: 10mm 8mm;\n  }\n\n  body.print-mode {\n    font-size: 8.5pt;\n    background-color: #fff !important;\n  }\n\n  .cards-container {\n    gap: 4mm;\n  }\n\n  .structure-card {\n    width: calc(50% - 2mm);\n    box-shadow: none;\n    border: 1px solid #ccc;\n    height: auto;\n  }\n\n  .card-image {\n    height: 140px;\n  }\n  .image-placeholder {\n    height: 140px;\n  }\n\n  .card-details {\n    font-size: 7.5pt;\n  }\n  .card-name {\n    font-size: 9pt;\n  }\n  .card-pricing {\n    font-size: 8pt;\n  }\n\n  .type-heading {\n    font-size: 12pt !important;\n    color: #000 !important;\n    border-bottom-color: #aaa !important;\n    margin-bottom: 3mm !important;\n  }\n\n  .printable-header h1 {\n    color: #000 !important;\n  }\n  .printable-header {\n    border-bottom-color: #888 !important;\n  }\n  .printable-footer {\n    border-top-color: #888 !important;\n    color: #000 !important;\n  }\n  .card-name {\n    color: #000 !important;\n  }\n\n  .description-link {\n    color: #000 !important;\n    text-decoration: underline !important;\n    word-break: break-all !important;\n  }\n  \n  .description-link::after {\n    content: \" (\" attr(href) \")\";\n    font-size: 7pt;\n    color: #666 !important;\n    text-decoration: none !important;\n  }\n\n  .bold-words {\n    font-weight: 600 !important;\n    color: #000 !important;\n  }\n\n  .card-info, .description-text {\n    word-wrap: break-word !important;\n    overflow-wrap: break-word !important;\n    word-break: break-word !important;\n    hyphens: auto !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
